/**
 * Shared matching for Command Center and Global Search (navigation + commands).
 * Includes multi-word queries and item id (e.g. "agents" id matches typed "agent").
 */
export function matchesDashboardSearch(
  query: string,
  parts: (string | undefined | null)[]
): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  const text = parts
    .filter((p): p is string => Boolean(p && String(p).trim()))
    .join(' ')
    .toLowerCase();
  if (text.includes(q)) return true;
  const words = q.split(/\s+/).filter((w) => w.length > 0);
  if (words.some((word) => text.includes(word))) return true;
  return false;
}
